
<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="100">
    <div class="mr-20" id="common-filter-date-from">
        <mat-form-field class="full-width-form-field" floatLabel="always">
            <mat-label>Desde ({{datePeriodTitle}})</mat-label>
            <input matInput [formControl]="PeriodFrom" (dateInput)="setDateFilter('F')" [matDatepicker]="fromPicker" autocomplete="off" [max]="maxDate">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <mat-error *ngIf="PeriodFrom.invalid && PeriodFrom.touched" class="error-space">
            <span *ngIf="PeriodFrom.hasError('required')">Se requiere valor</span>
            <span *ngIf="!PeriodFrom.hasError('required')">El formato de fecha no es válido (DD/MM/YYYY)</span>
        </mat-error>
    </div>
    
    <div id="common-filter-date-to" >
        <mat-form-field class="full-width-form-field" floatLabel="always">
            <mat-label>Hasta ({{datePeriodTitle}})</mat-label>
            <input matInput [formControl]="PeriodTo" (dateInput)="setDateFilter('T')" [matDatepicker]="toPicker" autocomplete="off" [min]="minDate">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
        
        <mat-error *ngIf="PeriodTo.invalid && PeriodTo.touched" class="error-space">
            <span *ngIf="PeriodTo.hasError('required')">Se requiere valor</span>
            <span *ngIf="!PeriodTo.hasError('required')">El formato de fecha no es válido (DD/MM/YYYY)</span>
        </mat-error>
    </div>
    
    <div  id="common-filter-date-dropdown">
        <button mat-button [matMenuTriggerFor]="periods" class="menu-dropdown menu-btn"><mat-icon>arrow_drop_down</mat-icon></button>
    
        <mat-menu #periods="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="day">Día</button>
            <button mat-menu-item [matMenuTriggerFor]="week">Semana</button>
            <button mat-menu-item [matMenuTriggerFor]="month">Mes</button>
            <button mat-menu-item [matMenuTriggerFor]="term">Trimestre</button>
            <button mat-menu-item [matMenuTriggerFor]="year">Año</button>
        </mat-menu>
        <mat-menu #day="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarDayOptions" (click)="setSelectedDate(calendarItem)">{{calendarItem.text + calendarItem.start}}</button>
        </mat-menu>
        
        <mat-menu #week="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarWeekOptions" (click)="setSelectedDate(calendarItem)">
                {{calendarItem.text + calendarItem.start + ".." + calendarItem.end}}
            </button>
        </mat-menu>
        
        <mat-menu #month="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarMonthOptions" (click)="setSelectedDate(calendarItem)">
                {{calendarItem.text + calendarItem.start + ".." + calendarItem.end}}
            </button>
            <button mat-menu-item [matMenuTriggerFor]="lastYearMonths">Año pasado</button>
            <button mat-menu-item [matMenuTriggerFor]="thisYearMonths">Este año</button>
        </mat-menu>
        <mat-menu #lastYearMonths="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarLastYearMonthOptions" (click)="setSelectedDate(calendarItem)">
                {{calendarItem.text + calendarItem.start + ".." + calendarItem.end}}
            </button>
        </mat-menu>
        <mat-menu #thisYearMonths="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarThisYearMonthOptions" (click)="setSelectedDate(calendarItem)">
                {{calendarItem.text + calendarItem.start + ".." + calendarItem.end}}
            </button>
        </mat-menu>
        
        <mat-menu #term="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarTermOptions" (click)="setSelectedDate(calendarItem)">
                {{calendarItem.text + calendarItem.start + ".." + calendarItem.end}}
            </button>
        </mat-menu>
        
        <mat-menu #year="matMenu" class="full-width">
            <button mat-menu-item *ngFor="let calendarItem of calendarYearOptions" (click)="setSelectedDate(calendarItem)">
                {{calendarItem.text + calendarItem.start + ".." + calendarItem.end}}
            </button>
        </mat-menu>
    </div>
</div>

